export class AttributeObject {
  label: string;
  type: "standard" | "geography" | "engagement" | "listMembership";
  attributes?: any;

  constructor(
    label: string,
    type: "standard" | "geography" | "engagement" | "listMembership",
    attributes?: any
  ) {
    this.label = label;
    this.type = type;
    this.attributes = attributes || undefined;
  }
}

export class AttributesReducerState {
  newList?: boolean;

  constructor(newList?: boolean) {
    this.newList = newList || false;
  }
}
